export const IS_NATIVE_APP = Boolean(window?.ReactNativeWebView);
